export const buildReviewForecast = (masteredWords = [], today) => {
  const forecast = {};
  (masteredWords || []).forEach((word) => {
    const label = word.sense_id && word.sense_id !== 'primary'
      ? `${word.word} (${word.definition_cn || word.sense_label || word.sense_id})`
      : word.word;
    const rawDates = Array.isArray(word.review_date) ? word.review_date : [];
    const nextDate = word.next_review_date || rawDates[0];
    const dates = new Set();
    if (nextDate && nextDate < today) {
      dates.add(today);
    } else {
      rawDates
        .filter((date) => typeof date === 'string' && date >= today)
        .forEach((date) => dates.add(date));
      if (nextDate && nextDate >= today) dates.add(nextDate);
    }
    dates.forEach((date) => {
      if (!forecast[date]) forecast[date] = [];
      forecast[date].push(label);
    });
  });
  return Object.entries(forecast)
    .map(([date, words]) => ({ date, count: words.length, words }))
    .sort((a, b) => dateSortValue(a.date) - dateSortValue(b.date));
};

const dateSortValue = (value) => Date.parse(`${value}T00:00:00Z`);
